// extracted by mini-css-extract-plugin
export default {"btnActive":"akhGN","menu":"iZra2"};